export enum ApiResourceName {
    saveIndusIndCompanyMapping = 'saveIndusIndCompanyMapping',
    inviteUserToCompanyByInternalAdmin = 'inviteUserToCompanyByInternalAdmin',
    // TODO: Add more
}